import {
  Component,
  OnInit,
  Input,
  Inject,
  Output,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Callout } from "../../models/callout";
import { CalloutComponent } from "../../blocks/callouts/components/callout/callout.component";
import { Observable } from "rxjs";
import { PageConfiguration } from "../../models/page-configuration";

@Component({
  selector: "app-callouts",
  templateUrl: "./callouts.component.html",
  styleUrls: ["./callouts.component.scss"],
})
export class CalloutsComponent implements OnInit {
  @Input() callouts: Array<Callout>;
  @Input() EnableRegistration: boolean;
  @Input() EnableSponsoredPins: boolean;
  @Input() RequestInfoForm: boolean;
  @Input() localStrings: Array<any>;
  @Input() hasShareForm: any;
  @Input() Guid: any;
  @Input() CountryID: any;
  @Input() AdditionalFieldsFormID: number;
  @Input() pageConfig: PageConfiguration;
  @Input() isHotelPromotion: boolean;
  @Input() promotionAlias: string;

  offerDetails: string | null;
  offerDetailsSidebar: string | null;
  constructor(
    private elRef: ElementRef,
    private cookieService: CookieService
  ) {}

  @ViewChild(CalloutComponent)
  private calloutComp: CalloutComponent;

  ngOnInit() {
    this.offerDetails = this.pageConfig.PromotionOfferDetails || null;
    this.offerDetailsSidebar =
      this.pageConfig.PromotionOfferDetailsSidebar || null;

    if (this.EnableSponsoredPins) {
      const sponsoredCallout = new Callout(
        null,
        null,
        this.pageConfig.SponsoredPinRegistrationCalloutHeadline,
        this.pageConfig.SponsoredPinRegistrationCalloutText,
        null,
        null,
        this.pageConfig.SponsoredPinRegistrationCalloutLabel,
        "registrationSponsor",
        this.pageConfig.SponsoredPinRegistrationCalloutImage
      );
      this.callouts.unshift(sponsoredCallout);
    }

    if (this.EnableRegistration) {
      const registerCallout = new Callout(
        null,
        null,
        this.localStrings["AV.Promotions.Hd.RegisterCallout"],
        this.localStrings["AV.Promotions.lb.RegisterCallout"],
        null,
        null,
        this.localStrings["AV.Promotions.btn.RegisterCallout"],
        "registration",
        "https://aplanbyvolvo.azureedge.net/media/av/media/aplan/callouts/get-pin.svg"
      );
      this.callouts.unshift(registerCallout);
    }

    if (this.hasShareForm) {
      const shareCallout = new Callout(
        null,
        null,
        this.localStrings["AV.Promotions.Hd.ShareCallout"],
        this.localStrings["AV.Promotions.lb.ShareCallout"],
        null,
        null,
        this.localStrings["AV.Promotions.btn.ShareCallout"],
        "share",
        "https://aplanbyvolvo.azureedge.net/media/av/media/aplan/callouts/share-icon.png"
      );
      this.callouts.push(shareCallout);
    }
  }

  openModal(modalName: string) {
    this.calloutComp.openModal(modalName);
  }
}
